// extracted by mini-css-extract-plugin
module.exports = {"taskHeader":"Header_taskHeader__32j4M","titleWrap":"Header_titleWrap__OYqFe","title":"Header_title__1UPpv"};